import { put } from 'redux-saga/effects';
import fetch from 'isomorphic-fetch';
import * as actions from '../actions/settingsActions';

export default function* getConfig(action) {
  const url = `/settings/${action.product}`;
  const config = yield fetch(url).then(response => response.json()).catch(err => err);
  yield put(actions.receiveConfig(config));
}
